"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormGroupColumns = exports.FormControlLabelAligned = exports.ActionsContainer = exports.Container = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var FormControlLabel_1 = __importDefault(require("../FormControlLabel"));
var FormGroup_1 = __importDefault(require("../FormGroup"));
exports.Container = styled_1.default.div({
    display: 'flex',
    flexDirection: 'column',
});
exports.ActionsContainer = styled_1.default.div({
    flex: '1',
    display: 'flex',
    justifyContent: 'space-between',
    pl: '45px',
});
exports.FormControlLabelAligned = (0, styled_1.default)(FormControlLabel_1.default)({
    marginLeft: 0, // override the -11px default
});
exports.FormGroupColumns = (0, styled_1.default)(FormGroup_1.default)(function (_a) {
    var options = _a.options;
    return ({
        display: 'grid',
        // the 200px is enough to max out at 4 columns for the max page container width
        gridTemplateColumns: options.length > 10 ? 'repeat(auto-fill, minmax(200px, 1fr))' : '1fr',
        pl: '45px',
        pr: 3,
    });
});
//# sourceMappingURL=styles.js.map